import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { ApiService } from '@services/api.service';
import { LancamentoEditCaixa } from '../models/lancamento-edit-caixa';
import { LoteLancamentoEditCaixa } from '../models/lote-lancamento-edit-caixa';
import { MovimentacaoCaixaInfo } from '../models/movimentacao-caixa-info';
import { MoverLancamentoDeLoteCaixa } from '../models/mover-lancamento-de-lote-caixa';

@Injectable({
  providedIn: 'root'
})
export class MovimentacaoCaixaApiService extends ApiService {

  baseUrlRoute: string = "movimentacao-caixa";

  constructor(
    public override http: HttpClient,
  ) {
    super(http);
  }

  public buscarLancamentosNoPeriodo(dataInicio: string, dataFim: string): Observable<MovimentacaoCaixaInfo> {
    return this.get<MovimentacaoCaixaInfo>(`/${this.baseUrlRoute}/${dataInicio}/${dataFim}`);
  }

  public editLote(lote: LoteLancamentoEditCaixa): Observable<LoteLancamentoEditCaixa> {
    return this.patch<LoteLancamentoEditCaixa>(`/${this.baseUrlRoute}/edit-nome-lote-lancamentos`, null, lote);
  }

  public patchLancamento(lancamento: LancamentoEditCaixa): Observable<void> {
    return this.patch<void>(`/lancamento-caixa/editar`, null, lancamento);
  }

  public deleteLancamento(lancamentoId: number): Observable<void> {
    return this.delete<void>(`/${this.baseUrlRoute}/lancamento/${lancamentoId}`);
  }

  public moverLancamentoDeLote(body: MoverLancamentoDeLoteCaixa): Observable<void> {
    return this.patch<void>(`/lancamento-caixa/mover-lote`, null, body);
  }
}
